export default "__VITE_ASSET__BuuXmLma__"